export const getTagTypeConfig = (tagTypeCode) => {
  switch (tagTypeCode) {
    case 'vocabulary_topic':
      return { 
        icon: 'category', 
        label: 'Topics', 
        colorClass: 'text-purple-500',
        bgClass: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400 border-purple-200 dark:border-purple-800'
      };
    case 'grammar':
      return { 
        icon: 'spellcheck', 
        label: 'Grammar', 
        colorClass: 'text-amber-500',
        bgClass: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 border-amber-200 dark:border-amber-800'
      };
    case 'vocabulary':
      return { 
        icon: 'match_word', 
        label: 'Vocabulary', 
        colorClass: 'text-blue-500',
        bgClass: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 border-blue-200 dark:border-blue-800'
      };
    default:
      return { 
        icon: 'label', 
        label: 'Tag', 
        colorClass: 'text-slate-500',
        bgClass: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-400 border-slate-200 dark:border-slate-700'
      };
  }
};
